import { StepsInfo } from 'types';

export const COUNTRY_OPTIONS = [
  { value: 'United States Of America', label: 'label_us' },
  { value: 'mx', label: 'label_mx' },
  { value: 'in', label: 'label_in' },
];

export const GENDER_OPTIONS = [
  { value: 'male', label: 'label_male' },
  { value: 'female', label: 'label_female' },
];

export const SEARCH_INITIAL_VALUES = {
  search: '',
};

export const fetchMXSteps = (
  isBDM: boolean,
  paths: { [key: string]: string }
): StepsInfo => {
  if (!isBDM) {
    return [
      {
        index: 0,
        type: 'companyInfo',
        label: 'title_company_info',
        pending: false,
        completed: false,
        route: paths.company,
      },
      {
        index: 1,
        type: 'financialInfo',
        label: 'title_financial_info',
        pending: false,
        completed: false,
        route: paths.financial,
      },
      {
        index: 2,
        type: 'buyerInfo',
        label: 'title_buyer_info',
        pending: false,
        completed: false,
        route: paths.buyer,
      },
      {
        index: 3,
        type: 'reviewInfo',
        label: 'title_review_and_submit',
        pending: false,
        completed: false,
        route: paths.review,
      },
    ];
  } else {
    return [
      {
        index: 0,
        type: 'companyInfo',
        label: 'title_company_info',
        pending: false,
        completed: false,
        route: paths.company,
      },
      {
        index: 1,
        type: 'financialInfo',
        label: 'title_financial_info',
        pending: false,
        completed: false,
        route: paths.financial,
      },
      {
        index: 2,
        type: 'buyerInfo',
        label: 'title_buyer_info',
        pending: false,
        completed: false,
        route: paths.buyer,
      },
    ];
  }
};

export const fetchINSteps = (
  isBDM: boolean,
  paths: { [key: string]: string }
): StepsInfo => {
  if (!isBDM) {
    return [
      {
        index: 0,
        type: 'companyInfo',
        label: 'title_company_info',
        pending: false,
        completed: false,
        route: paths.company,
      },
      {
        index: 1,
        type: 'financialInfo',
        label: 'title_financial_info',
        pending: false,
        completed: false,
        route: paths.financial,
      },
      {
        index: 2,
        type: 'buyerInfo',
        label: 'title_buyer_info',
        pending: false,
        completed: false,
        route: paths.buyer,
      },
      {
        index: 3,
        type: 'reviewInfo',
        label: 'title_review_and_submit',
        pending: false,
        completed: false,
        route: paths.review,
      },
    ];
  } else {
    return [
      {
        index: 0,
        type: 'companyInfo',
        label: 'title_company_info',
        pending: false,
        completed: false,
        route: paths.company,
      },
      {
        index: 1,
        type: 'financialInfo',
        label: 'title_financial_info',
        pending: false,
        completed: false,
        route: paths.financial,
      },
      {
        index: 2,
        type: 'buyerInfo',
        label: 'title_buyer_info',
        pending: false,
        completed: false,
        route: paths.buyer,
      },
    ];
  }
};

export const fetchUSSteps = (paths: { [key: string]: string }): StepsInfo => {
  return [
    {
      index: 0,
      type: 'introduction',
      label: 'usoa_intro_title',
      pending: false,
      completed: true,
      route: paths.introduction,
    },
    {
      index: 1,
      type: 'companyInfo',
      label: 'usoa_cd_title',
      pending: false,
      completed: false,
      route: paths.company,
    },
    {
      index: 2,
      type: 'personalDetails',
      label: 'usoa_pd_title',
      pending: false,
      completed: false,
      route: paths.personal,
    },
    {
      index: 3,
      type: 'bankInfo',
      label: 'usoa_bd_connect_bank_accounts',
      pending: false,
      completed: false,
      route: paths.bank,
    },
    {
      index: 4,
      type: 'financialInfo',
      label: 'usoa_bd_upload_docs',
      pending: false,
      completed: false,
      route: paths.financial,
    },
    {
      index: 5,
      type: 'reviewInfo',
      label: 'title_review_and_submit',
      pending: false,
      completed: false,
      route: paths.review,
    },
  ];
};

export const fetchCPSteps = (paths: { [key: string]: string }): StepsInfo => {
  return [
    {
      index: 0,
      type: 'introduction',
      label: 'usoa_intro_title',
      pending: false,
      completed: true,
      route: paths.introduction,
    },
    {
      index: 1,
      type: 'companyInfo',
      label: 'usoa_cd_title',
      pending: false,
      completed: false,
      route: paths.company,
    },
    {
      index: 2,
      type: 'personalDetails',
      label: 'usoa_pd_title',
      pending: false,
      completed: false,
      route: paths.personal,
    },
    {
      index: 3,
      type: 'bankInfo',
      label: 'usoa_bd_connect_bank_accounts',
      pending: false,
      completed: false,
      route: paths.bank,
    },
    {
      index: 4,
      type: 'financialInfo',
      label: 'usoa_bd_upload_docs',
      pending: false,
      completed: false,
      route: paths.financial,
    },
  ];
};

export const fetchLegalSteps = (
  paths: {
    [key: string]: string;
  },
  inspectionType: boolean,
  isACHEnabled: boolean
): StepsInfo => {
  const steps = [
    {
      index: 0,
      type: 'introduction',
      label: 'usoa_intro_title',
      pending: false,
      completed: true,
      route: paths.legalapplication,
    },

    {
      index: 1,
      type: 'identity_verification',
      label: 'usoa_verification',
      pending: true,
      completed: false,
      route: paths.legalapplication,
    },
    {
      index: 2,
      type: 'esign_document',
      label: 'usoa_esign_document_title',
      pending: true,
      completed: false,
      route: paths.legalapplication,
    },
  ];
  if (isACHEnabled) {
    steps.push({
      index: 3,
      type: 'ach_authorization',
      label: 'usoa_ach_authorization_title',
      pending: true,
      completed: false,
      route: paths.legalachauthorization,
    });
  }
  if (inspectionType) {
    const index = isACHEnabled ? 4 : 3;
    steps.push({
      index: index,
      type: 'virtual_site_visit',
      label: 'usoa_virtual_site_visit_title',
      pending: true,
      completed: false,
      route: paths.legalvirtualsitevisit || paths.introduction,
    });
  }
  return steps;
};
